import { RootState } from "@/infrastructure/rootState";
import { oc } from "ts-optchain";

export const exchangeCountryMap = (state: RootState) => state.firestore.data.exchanges.exchangeCountryMapper;
export const countryExchange = (state: RootState) => oc(state.firestore.data).exchanges.info.countryExchange([]);


export const backtestSnapshot = (state: RootState) => {
  const backtest_snapshot = state.firestore.data.backtest_snapshot;

  return backtest_snapshot ? Object.values(backtest_snapshot) : [];
};